import appSettings from 'wanderu-config';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';

import frontEndValidations from '../../../frontEndValidations';
import {
    actions as bookingActions,
    selectors as bookingSelectors,
} from '../../appstate';
import { removeValidationForUnmodifiedFields } from '../utils';
import { backendValidations } from '../validateForm';
import {
    actions,
    namespace,
    reducer,
    selectors,
} from './base';

const logger = Logger.getLogger('wanderu-app-booking:validateStep');

const INVALID_STEP_ERROR_CODE = 1100;

function createInvalidError() {
    let invalidError = new Error(INVALID_STEP_ERROR_CODE);
    invalidError.code = INVALID_STEP_ERROR_CODE;
    return invalidError;
}

function validateStep(fieldsSelector) {
    return async (dispatch, getState) => {
        dispatch(actions.reset());
        dispatch(actions.startWork());

        const fields = fieldsSelector(getState());
        dispatch(bookingActions.setFieldsModified(fields));

        const {
            validatedForm,
            isValid,
        } = frontEndValidations({ fields });

        if (!isValid) {
            dispatch(bookingActions.setValidations({ fields: validatedForm }));
            throw createInvalidError();
        }
        const bookingForm = bookingSelectors.selectFormData(getState());

        let error;

        try {
            const backendFields = await backendValidations(getState(), { cancelable: false });

            const validationFields = removeValidationForUnmodifiedFields(bookingForm, backendFields)
            || [];

            dispatch(bookingActions.setValidations({ fields: validationFields }));

            const updatedFields = fieldsSelector(getState());
            const insuranceVisible = bookingSelectors.selectInsuranceVisible(getState());

            if (!bookingSelectors.selectFieldsAreValid(updatedFields, insuranceVisible)) {
                throw createInvalidError();
            }
        } catch (ex) {
            if (ex.name !== 'AbortError') {
                const domainUserInfo = appSettings.env.isClient
                    ? SnowplowService.getDomainUserInfo()
                    : {};

                logger.error('post', ex, {
                    snowplowIds: {
                        networkUserId: SnowplowService.getNetworkUserId(),
                        ...domainUserInfo,
                    },
                });
            }

            error = {
                code: ex.code,
                message: ex.message,
                name: ex.name,
            };
        } finally {
            dispatch(actions.endWork({}, error));
        }
    };
}

const validateStepAction = {
    validateStep,
    ...selectors,
    ...actions,
};

export {
    validateStepAction,
};

const validateStepSlice = {
    [namespace]: reducer,
};

export default validateStepSlice;
